import React from 'react';
import { Link } from 'react-router-dom';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-forest text-cream">
      <div className="container-narrow py-16">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-10">
          <div className="lg:col-span-2">
            <Link to="/" className="inline-block mb-4">
              <img
                src="/assets/Logo.png"
                alt="Inerva Psicología"
                className="h-24 md:h-28 w-auto brightness-0 invert"
              />
            </Link>
            <p className="text-cream-70 max-w-sm">
              Clínica online de psicología. Un espacio seguro, afirmativo y sin juicios
              donde acompañarte en tu proceso.
            </p>
          </div>

          <div>
            <h4 className="text-lg font-serif mb-5 text-cream">Enlaces</h4>
            <nav className="flex flex-col gap-3">
              <a href="/#sobre-inerva" className="text-cream-70 hover:text-cream transition-colors">
                Quiénes somos
              </a>
              <a href="/#servicios" className="text-cream-70 hover:text-cream transition-colors">
                Servicios
              </a>
              <Link to="/blog" className="text-cream-70 hover:text-cream transition-colors">
                Blog
              </Link>
              <a href="/#contacto" className="text-cream-70 hover:text-cream transition-colors">
                Contacto
              </a>
            </nav>
          </div>

          <div>
            <h4 className="text-lg font-serif mb-5 text-cream">Contacto</h4>
            <div className="flex flex-col gap-3">
              <a
                href="tel:+34626235122"
                className="text-cream-70 hover:text-cream transition-colors flex items-center gap-2"
              >
                <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                </svg>
                626 235 122
              </a>
              <a
                href="mailto:inerva.psicologia@gmail.com"
                className="text-cream-70 hover:text-cream transition-colors flex items-center gap-2 text-sm"
              >
                <svg className="w-4 h-4 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                </svg>
                inerva.psicologia@gmail.com
              </a>
            </div>

            <div className="mt-6 flex gap-4">
              <a
                href="https://www.instagram.com/inervapsicologia"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-full bg-cream/10 no-underline flex items-center justify-center text-cream-70 hover:text-cream hover:bg-cream/20 transition-all"
                aria-label="Instagram"
              >
                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z" />
                </svg>
              </a>
            </div>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-cream/10">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-cream-50 text-sm">
              © {currentYear} Inerva Psicología. Todos los derechos reservados.
            </p>
            <nav className="flex gap-6 text-sm">
              <Link to="/privacidad" className="text-cream-50 hover:text-cream transition-colors">
                Privacidad
              </Link>
              <Link to="/cookies" className="text-cream-50 hover:text-cream transition-colors">
                Cookies
              </Link>
              <Link to="/aviso-legal" className="text-cream-50 hover:text-cream transition-colors">
                Aviso Legal
              </Link>
            </nav>
          </div>
        </div>
      </div>
    </footer>
  );
}
